import React from 'react';
import { PageForm } from '/src/layouts/page';
import DatasetForm from '../../features/dataset/components/form/DatasetForm/DatasetForm';
import QuotePart from '/src/components/quote/QuotePart';

function DatasetCreate() {
    return (

        <PageForm>
            <DatasetForm type='create'/>
            <QuotePart />
        </PageForm>

    );
}
export default DatasetCreate;